import { type FC } from 'react';
import { Text } from '@direct-frontend/components';
import { PAGE_TITLE_PROMOTION } from '#shared/lib/constants';
import { getSafeStoreProgramContext } from '#shared/lib/context';
import { promotionRoute } from '#shared/lib/routes';
import { type SidebarMenuItem } from '../types';
import styles from '../../DashboardLayout@desktop.module.css';

const GetPromotionMenuItemTitle: FC = () => {
    const { currentProgram } = getSafeStoreProgramContext();

    /** Условие для того, чтобы настроить цвет для промо-пункта меню в sidebar */
    if (currentProgram === 'NONE') {
        return (
            <Text className={styles.promotionListItem} bold size="s">
                {PAGE_TITLE_PROMOTION}
            </Text>
        );
    }

    return <>{PAGE_TITLE_PROMOTION}</>;
};

export const PROMOTION_MENU_ITEM: SidebarMenuItem = {
    href: promotionRoute.getUrl(),
    iconLabel: '',
    itemId: 'promotion',
    permission: 'store_promotion',
    routes: [promotionRoute.route],
    label: PAGE_TITLE_PROMOTION,
    title: <GetPromotionMenuItemTitle />,
};
